<template>
  <div
    class="help"
    :class="{
      'help--open': status === 'open',
      'help--fullscreen': currentSection !== 'main'
    }"
  >
    <div class="help-wrapper" :data-current-section="currentSection">
      <!-- MAIN SECTION -->
      <div class="help-section help-main">
        <div class="help--row help-title f-m"><p>Hai bisogno d'aiuto?</p></div>
        <div class="help--row cursor-pointer" @click="openSection('contacts')">
          <p>Contattaci</p>
        </div>
        <div
          class="help--row cursor-pointer"
          @click="openSection('documentation')"
        >
          <p>Consulta la documentazione</p>
        </div>
        <div class="help--row cursor-pointer" @click="openSection('faq')">
          <p>Consulta le FAQ</p>
        </div>
        <div
          v-if="fromApp"
          class="help--row cursor-pointer"
          @click="backHome()"
        >
          <p>Torna alla Home</p>
        </div>
        <div class="help--row help-undo cursor-pointer" @click="closeHelp">
          <p>Annulla</p>
        </div>
      </div>

      <!-- CONTACTS SECTION -->
      <HelpContacts />

      <!-- DOCUMENTATION SECTION -->
      <HelpDocumentation />

      <!-- FAQ SECTION -->
      <!-- in order to improve performance, this variable is used
           to render FAQ content iframe just one time and only when needed (on click) -->
      <HelpFAQ v-if="faqLoaded" />
    </div>
  </div>
</template>

<script>
import HelpContacts from "./HelpContacts";
import HelpDocumentation from "./HelpDocumentation";
import HelpFAQ from "./HelpFAQ";
import UtilityService from "@/services/UtilityService";

export default {
  name: "Help",
  components: {
    HelpContacts,
    HelpDocumentation,
    HelpFAQ
  },

  data() {
    return {
      status: "closed",
      currentSection: "main",
      faqLoaded: false,
      fromApp: false
    };
  },
  mounted() {
    this.$root.$on("openHelp", this.openHelp);
    this.$root.$on("closeHelp", this.closeHelp);
    this.$root.$on("helpBack", this.backHelp);
    this.fromApp = !!sessionStorage.getItem("fromApp");
  },
  methods: {
    openHelp() {
      this.status = "open";
      this.$root.$emit("openedHelp");
    },
    closeHelp() {
      this.status = "closed";
      this.currentSection = "main";
      this.$root.$emit("closedHelp");
    },
    backHelp() {
      this.openSection("main");
    },
    backHome() {
      UtilityService.backToInitialView();
    },
    openSection(section) {
      this.currentSection = section;
      if (section === "faq") {
        this.faqLoaded = true;
      }
    }
  }
};
</script>

<style lang="less">
@borderColor: #eaeaea;

.help {
  position: fixed;
  background: white;
  left: 0;
  width: 100%;
  transition: all 0.3s;
  height: 250px;
  bottom: -250px;
  z-index: 1;
  //padding: 20px 0px;
  -webkit-box-shadow: 0px -2px 5px 0px #818181bf;
  -moz-box-shadow: 0px -2px 5px 0px #818181bf;
  box-shadow: 0px -2px 5px 0px #818181bf;
  border-radius: 15px 15px 0 0px;

  &.help--fullscreen {
    height: 100%;
  }

  .help-wrapper {
    height: 100%;
    .help-section {
      height: 100%;
      flex-direction: column;
      .section-header {
        display: flex;
        font-size: 24px;
        padding: 15px;
        align-items: center;
      }
      .section-intro {
        padding: 0 20px;
        border-bottom: 1px solid @borderColor;
        &--title {
          font-size: 16px;
          margin-bottom: 10px;
        }
      }
      .section-content {
        overflow: auto;
        .section-row {
          min-height: 50px;
          display: flex;
          align-items: center;
          padding: 5px 20px;
          border-bottom: 1px solid @borderColor;

          &.section-row--twolines {
            flex-direction: column;
            align-items: baseline;
            justify-content: center;
            height: 70px;
          }
        }
      }
    }
  }

  &--row {
    height: 100%;
    border-bottom: 1px solid @borderColor;
    display: flex;
    justify-content: center;
    align-items: center;
    &.help-title {
      font-size: 16px;
    }
    &.help-undo {
      color: #666666;
    }
  }

  &--open {
    bottom: 0;
  }

  .help-section {
    display: none;
  }
  [data-current-section="main"] {
    .help-main {
      display: flex;
    }
  }
  [data-current-section="contacts"] {
    .help-contacts {
      display: flex;
    }
  }
  [data-current-section="documentation"] {
    .help-documentation {
      display: flex;
    }
  }
  [data-current-section="faq"] {
    .help-faq {
      display: flex;
    }
  }
}

@media (min-width: 768px) {
  .help {
    width: 300px;
    right: -400px;
    bottom: 0;
    left: auto;
    &.help--open {
      right: 0px;
    }
    &.help--fullscreen {
      height: 570px;
    }
  }
}
@media (max-width: 768px) {
  #chorallyChatContainer {
    left: 0 !important;
    right: 0 !important;
    width: 100%;
    height: 100%;
    &.resize {
      width: 100px;
    }
  }
}
</style>
